import React, { useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import FreidoraInfo from './FreidoraInfo';
import polloImg from '../../assets/pollo.png'
import papaImg from '../../assets/papa.png'
const server = process.env.REACT_APP_SERVER;

function ItemSucursalTms(props) {
    const { sucursal,aceites,setLoading, actualizar } = props;
    const [infoFreidoras, setInfoFreidoras] = useState([]);
    const [idEmpleado, setIdEmpleado] = useState(0);
    function getInformacion() {
        var info = JSON.parse(localStorage.getItem('info'));
        setIdEmpleado(info.ID_EMPLEADO);
        fetch(`${server}/reporte/getInfoFreidoras`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                ...sucursal, 'idEmpleado': info.ID_EMPLEADO
            })
        })
            .then(res => res.json())
            .then(data => {
                setLoading(false);
                if (data.ok) {
                    setInfoFreidoras(data.ok);
                } else {
                    console.log(data.error)
                }
            })
            .catch(error => MsgUtils.msgError(error));
    }
    function getTitulo(dato) {
        if (dato.TIPO == 'Pollo') {
            return <span className='fw-bold' style={{fontSize:'22px'}}>{dato.ID_FREIDORA +' '+dato.TIPO} <img style={{ width: '20px' }} src={polloImg}></img></span>
        } else {
            return <span className='fw-bold' style={{fontSize:'22px'}}>{dato.ID_FREIDORA +' '+dato.TIPO} <img style={{ width: '20px' }} src={papaImg}></img></span>
        }
    }
    useEffect(() => {
        setLoading(true);
        getInformacion()
    }, [sucursal,actualizar])
    return (
        <>
            <div className='container-fluid text-light text-center fw-bold bg-secondary py-1'>
                <div className='btn-group px-2'>
                    {aceites.map((item, index)=>{
                        return( 
                        <div className={`btn btn-sm ${item.ID_PRODUCTO==195?'btn-success':'btn-primary'}`} key={index}>
                            <div className='container-fluid'>
                                <div><i className="fa-solid fa-bottle-droplet"></i> <span>{item.STOCK+' '+item.SIMBOLO}</span></div>
                                <div style={{fontSize:'10px'}}>{item.ID_PRODUCTO==195?'vegetal':'hidrogenado'}</div>
                            </div>
                        </div>
                    )})}
                </div>
                {sucursal.SUCURSAL}
            </div>
            <div className='container-fluid '>
                <div className='row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-1'>
                    {infoFreidoras.map((item, index) => {
                        return (
                            <div className='col mb-2' key={index}>
                                <div className=' container-fluid bg-dark bg-gradient text-center text-light fw-bold' >
                                    {getTitulo(item)}
                                </div>
                                <FreidoraInfo infor={item} sucursal={sucursal} idEmpleado={idEmpleado} tipoF={item.TIPO} />
                            </div>
                        )
                    })}
                </div>
            </div>
        </>
    )
}

export default ItemSucursalTms